'use client';

import { cleanupLegacyServiceWorkers } from '@/utils/legacyServiceWorkerCleanup';
import { useEffect } from 'react';

/**
 * Limpieza del worker viejo de next-pwa, SIN feature flag y en todas las pantallas (también
 * auth): una vez por carga, sin reload. No toca el service worker de push.
 */
const ServiceWorkerCleanup = () => {
  useEffect(() => {
    cleanupLegacyServiceWorkers();
  }, []);

  return null;
};

export default ServiceWorkerCleanup;
